import { render, staticRenderFns } from "./horoscope.vue?vue&type=template&id=d61bf992&scoped=true"
import script from "./horoscope.vue?vue&type=script&lang=js"
export * from "./horoscope.vue?vue&type=script&lang=js"
import style0 from "./horoscope.vue?vue&type=style&index=0&id=d61bf992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61bf992",
  null
  
)

export default component.exports